import React from "react";
import {
  AutocompleteInput,
  DateInput,
  Filter,
  ReferenceInput,
  SelectInput,
  TextInput,
} from "react-admin";
import BusinessUnitInput from "../../components/inputs/BusinessUnitInput";
import { BookingStatus } from "./util";

const BookingFilter: React.FC<any> = (props) => {
  return (
    <Filter {...props}>
      <TextInput label="Booking ID" source="id" />
      <SelectInput
        source="status"
        choices={[
          { id: BookingStatus.NEW, name: "New" },
          { id: BookingStatus.ACCEPTED, name: "Accepted" },
          { id: BookingStatus.DELIVERED, name: "Delivered" },
          { id: BookingStatus.ALLOCATED, name: "Allocated" },
          { id: BookingStatus.SURGERY_STARTED, name: "Surgery Started" },
          { id: BookingStatus.REPORT_SUBMITTED, name: "Report Submitted" },
          { id: BookingStatus.INVOICED, name: "Invoiced Only" },
          {
            id: BookingStatus.TOPPED_UP,
            name:
              process.env.REACT_APP_COMPANY_CODE === "STMY"
                ? "Returned Only"
                : "Topped Up Only",
          },
          {
            id: BookingStatus.INVOICED_TOPPED_UP,
            name:
              process.env.REACT_APP_COMPANY_CODE === "STMY"
                ? "Invoiced and Returned"
                : "Invoiced and Topped Up",
          },
          { id: BookingStatus.CANCELLED, name: "Cancelled" },
          {
            id: BookingStatus.CANCELLATION_REQUEST,
            name: "Cancellation Request",
          },
          {
            id: BookingStatus.NO_USAGE,
            name: "No Usage",
          },
        ]}
      />
      <DateInput source="date" />
      <ReferenceInput
        label="Consultant"
        source="consultant_id"
        reference="consultants"
      >
        <AutocompleteInput
          optionText="full_name"
          shouldRenderSuggestions={(val: string) => {
            return val.trim().length > 2;
          }}
        />
      </ReferenceInput>
      <ReferenceInput label="Venue" source="hospital_id" reference="hospitals">
        <AutocompleteInput
          optionText="name"
          shouldRenderSuggestions={(val: string) => {
            return val.trim().length > 2;
          }}
        />
      </ReferenceInput>
      <ReferenceInput
        label={
          process.env.REACT_APP_COMPANY_CODE === "STMY"
            ? "Order Type"
            : "Procedure"
        }
        source="procedure_id"
        reference="procedures"
        sort={{ field: "name", order: "ASC" }}
      >
        <AutocompleteInput
          optionText="name"
          shouldRenderSuggestions={(val: string) => {
            return val.trim().length > 2;
          }}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Surgeon"
        source="surgeon_id"
        reference="surgeons"
        sort={{ field: "name", order: "ASC" }}
        filter={{ status: "active" }}
      >
        <AutocompleteInput
          optionText="full_name"
          shouldRenderSuggestions={(val: string) => {
            return val.trim().length > 2;
          }}
        />
      </ReferenceInput>
      <BusinessUnitInput source="business_unit_id" />
    </Filter>
  );
};

export default BookingFilter;
